import { AutoComplete, useFormContext } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useMemo } from "react";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { TTicketAutoTransferRuleForm } from "../TicketAutoTransferRuleSchema";
import { useTicketChannelSteps } from "./useTicketChannelSteps";
import TicketChannel from "../TicketChannel";

const translationPath = "page.settings.crm.ticketAutoTransferRules.";

export const TicketChannelStep = memo(() => {
  const { t } = useTranslation();
  const { control } = useFormContext<TTicketAutoTransferRuleForm>();
  const { ticketChannelSteps } = useTicketChannelSteps("ticketChannel");

  const ticketChannelStepTransfer = useWatch({
    name: "ticketChannelStepTransfer",
    control,
  });

  const ticketChannelStepOptions = useMemo(
    () =>
      ticketChannelStepTransfer
        ? ticketChannelSteps.filter(
            (item) => item.id !== ticketChannelStepTransfer.id
          )
        : ticketChannelSteps,
    [ticketChannelStepTransfer, ticketChannelSteps]
  );

  return (
    <>
      <TicketChannel
        name="ticketChannel"
        ticketChannelStepFieldName="ticketChannelStep"
      />
      <Grid item xs={12} sm={6}>
        <AutoComplete
          getOptionLabel={(option) => {
            return option.name;
          }}
          size="small"
          label={t(translationPath + "ticket_channel_step")}
          name="ticketChannelStep"
          options={ticketChannelStepOptions}
        />
      </Grid>
    </>
  );
});
